var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticStyle:{"padding":"10px"}},[_c('div',{staticStyle:{"width":"100%","height":"5vh","background-color":"white"}},[_c('daily-rain')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }